export default __webpack_public_path__ + "static/media/Version (4) - Half-Blood Prince_05.3720c332.jpg";